export default __webpack_public_path__ + "static/media/userImage.15add386.png";